import {ICategory} from "../../../../services/model/Category";
import React from "react";
import {Link} from "react-router-dom";
import styles from "./subCategoryContainer.module.css";

interface Props {
    categoryName: string;
    subCategory: ICategory;
}

const SubCategoryContainer: React.FC<Props> = (props) => {

    const handleSubcategoryClick = (e: React.MouseEvent, url: string) => {
        e.preventDefault();
        window.location.href = url;
    };

    return (

        <Link
            key={props.subCategory.name}
            to={`/corals/${props.categoryName.toLowerCase()}/${props.subCategory.name.toLowerCase()}`}
            style={{ textDecoration: 'none', color: 'inherit' }}
            onClick={(e) => handleSubcategoryClick(e, `/corals/${props.categoryName.toLowerCase()}/${props.subCategory.name.toLowerCase()}`)}
        >
            <div key={props.subCategory.name} className={styles.subCategoryContainer}>
                <img src={props.subCategory.imageUrl} alt={props.subCategory.name} className={styles.subCategoryImage} />
                <span>{props.subCategory.name}</span>
            </div>
        </Link>
    )


}

export default SubCategoryContainer;